import { Breadcrumbs } from "../breadcrumbs";
import { DevicesTable } from "../tables/devices-table";

export function DevicesPage() {
	return (
		<div className="space-y-2">
			<Breadcrumbs />
			<div className="flex flex-col">
				<div className="flex justify-between">
					<h2>Registered Devices</h2>
				</div>
				<DevicesTable />
			</div>
		</div>
	);
}
